import React from 'react'
import { Link } from 'react-router-dom'

const SideBar = () => {
  return (
    <div className="sidebar-page-container">
  <div className="auto-container">
    <div className="row clearfix">
      {/*Content Side / Blog Sidebar*/}
      <div className="content-side col-lg-8 col-md-12 col-sm-12">
        <div className="our-shop">
          <div className="row">
            {/* Shop Item */}
            <div className="single-product-item col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="img-holder">
                <Link  to="shop-detail.html">
                  <img
                    width={270}
                    height={300}
                    src="/assets/images/resource/products/1.jpg"
                    className=""
                    alt=""
                  />
                </Link> 
              </div>
              <div className="title-holder text-center">
                <div className="static-content">
                  <h3 className="title text-center">
                    <Link  to="shop-detail.html">Product 01</Link> 
                  </h3>
                  <span className="price">
                    <span className="amount">
                      <span className="">$</span>90.00
                    </span>
                  </span>
                </div>
                <div className="overlay-content">
                  <ul className="clearfix">
                    <li>
                      <Link  to="shopping-cart.html">
                        <span className="fa fa-shopping-cart" />
                        <div className="toltip-content">
                          <p>Add to Cart</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link  to="shop-detail.html" className="">
                        <span className="fa fa-heart" />
                        <div className="toltip-content">
                          <p>Add Whishlist</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link 
                        to="images/resource/products/1.jpg"
                        className="lightbox-image"
                        data-fancybox="shop-gallery"
                      >
                        <span className="fa fa-expand" />
                        <div className="toltip-content">
                          <p>Zoom In</p>
                        </div>
                      </Link> 
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Shop Item */}
            <div className="single-product-item col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="img-holder">
                <Link  to="shop-detail.html">
                  <img
                    width={270}
                    height={300}
                    src="/assets/images/resource/products/2.jpg"
                    className=""
                    alt=""
                  />
                </Link> 
              </div>
              <div className="title-holder text-center">
                <div className="static-content">
                  <h3 className="title text-center">
                    <Link  to="shop-detail.html">Product 02</Link> 
                  </h3>
                  <span className="price">
                    <span className="amount">
                      <span className="">$</span>90.00
                    </span>
                  </span>
                </div>
                <div className="overlay-content">
                  <ul className="clearfix">
                    <li>
                      <Link  to="shopping-cart.html">
                        <span className="fa fa-shopping-cart" />
                        <div className="toltip-content">
                          <p>Add to Cart</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link  to="shop-detail.html" className="">
                        <span className="fa fa-heart" />
                        <div className="toltip-content">
                          <p>Add Whishlist</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link 
                        to="images/resource/products/1.jpg"
                        className="lightbox-image"
                        data-fancybox="shop-gallery"
                      >
                        <span className="fa fa-expand" />
                        <div className="toltip-content">
                          <p>Zoom In</p>
                        </div>
                      </Link> 
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Shop Item */}
            <div className="single-product-item col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="img-holder">
                <Link  to="shop-detail.html">
                  <img
                    width={270}
                    height={300}
                    src="/assets/images/resource/products/3.jpg"
                    className=""
                    alt=""
                  />
                </Link> 
              </div>
              <div className="title-holder text-center">
                <div className="static-content">
                  <h3 className="title text-center">
                    <Link  to="shop-detail.html">Product 03</Link> 
                  </h3>
                  <span className="price">
                    <span className="amount">
                      <span className="">$</span>90.00
                    </span>
                  </span>
                </div>
                <div className="overlay-content">
                  <ul className="clearfix">
                    <li>
                      <Link  to="shopping-cart.html">
                        <span className="fa fa-shopping-cart" />
                        <div className="toltip-content">
                          <p>Add to Cart</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link  to="shop-detail.html" className="">
                        <span className="fa fa-heart" />
                        <div className="toltip-content">
                          <p>Add Whishlist</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link 
                        to="images/resource/products/1.jpg"
                        className="lightbox-image"
                        data-fancybox="shop-gallery"
                      >
                        <span className="fa fa-expand" />
                        <div className="toltip-content">
                          <p>Zoom In</p>
                        </div>
                      </Link> 
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Shop Item */}
            <div className="single-product-item col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="img-holder">
                <Link  to="shop-detail.html">
                  <img
                    width={270}
                    height={300}
                    src="/assets/images/resource/products/4.jpg"
                    className=""
                    alt=""
                  />
                </Link> 
              </div>
              <div className="title-holder text-center">
                <div className="static-content">
                  <h3 className="title text-center">
                    <Link  to="shop-detail.html">Product 04</Link> 
                  </h3>
                  <span className="price">
                    <span className="amount">
                      <span className="">$</span>90.00
                    </span>
                  </span>
                </div>
                <div className="overlay-content">
                  <ul className="clearfix">
                    <li>
                      <Link  to="shopping-cart.html">
                        <span className="fa fa-shopping-cart" />
                        <div className="toltip-content">
                          <p>Add to Cart</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link  to="shop-detail.html" className="">
                        <span className="fa fa-heart" />
                        <div className="toltip-content">
                          <p>Add Whishlist</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link 
                        to="images/resource/products/1.jpg"
                        className="lightbox-image"
                        data-fancybox="shop-gallery"
                      >
                        <span className="fa fa-expand" />
                        <div className="toltip-content">
                          <p>Zoom In</p>
                        </div>
                      </Link> 
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Shop Item */}
            <div className="single-product-item col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="img-holder">
                <Link  to="shop-detail.html">
                  <img
                    width={270}
                    height={300}
                    src="/assets/images/resource/products/5.jpg"
                    className=""
                    alt=""
                  />
                </Link> 
              </div>
              <div className="title-holder text-center">
                <div className="static-content">
                  <h3 className="title text-center">
                    <Link  to="shop-detail.html">Product 05</Link> 
                  </h3>
                  <span className="price">
                    <span className="amount">
                      <span className="">$</span>90.00
                    </span>
                  </span>
                </div>
                <div className="overlay-content">
                  <ul className="clearfix">
                    <li>
                      <Link  to="shopping-cart.html">
                        <span className="fa fa-shopping-cart" />
                        <div className="toltip-content">
                          <p>Add to Cart</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link  to="shop-detail.html" className="">
                        <span className="fa fa-heart" />
                        <div className="toltip-content">
                          <p>Add Whishlist</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link 
                        to="images/resource/products/1.jpg"
                        className="lightbox-image"
                        data-fancybox="shop-gallery"
                      >
                        <span className="fa fa-expand" />
                        <div className="toltip-content">
                          <p>Zoom In</p>
                        </div>
                      </Link> 
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Shop Item */}
            <div className="single-product-item col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="img-holder">
                <Link  to="shop-detail.html">
                  <img
                    width={270}
                    height={300}
                    src="/assets/images/resource/products/6.jpg"
                    className=""
                    alt=""
                  />
                </Link> 
              </div>
              <div className="title-holder text-center">
                <div className="static-content">
                  <h3 className="title text-center">
                    <Link  to="shop-detail.html">Product 06</Link> 
                  </h3>
                  <span className="price">
                    <span className="amount">
                      <span className="">$</span>90.00
                    </span>
                  </span>
                </div>
                <div className="overlay-content">
                  <ul className="clearfix">
                    <li>
                      <Link  to="shopping-cart.html">
                        <span className="fa fa-shopping-cart" />
                        <div className="toltip-content">
                          <p>Add to Cart</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link  to="shop-detail.html" className="">
                        <span className="fa fa-heart" />
                        <div className="toltip-content">
                          <p>Add Whishlist</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link 
                        to="images/resource/products/1.jpg"
                        className="lightbox-image"
                        data-fancybox="shop-gallery"
                      >
                        <span className="fa fa-expand" />
                        <div className="toltip-content">
                          <p>Zoom In</p>
                        </div>
                      </Link> 
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Shop Item */}
            <div className="single-product-item col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="img-holder">
                <Link  to="shop-detail.html">
                  <img
                    width={270}
                    height={300}
                    src="/assets/images/resource/products/7.jpg"
                    className=""
                    alt=""
                  />
                </Link> 
              </div>
              <div className="title-holder text-center">
                <div className="static-content">
                  <h3 className="title text-center">
                    <Link  to="shop-detail.html">Product 07</Link> 
                  </h3>
                  <span className="price">
                    <span className="amount">
                      <span className="">$</span>90.00
                    </span>
                  </span>
                </div>
                <div className="overlay-content">
                  <ul className="clearfix">
                    <li>
                      <Link  to="shopping-cart.html">
                        <span className="fa fa-shopping-cart" />
                        <div className="toltip-content">
                          <p>Add to Cart</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link  to="shop-detail.html" className="">
                        <span className="fa fa-heart" />
                        <div className="toltip-content">
                          <p>Add Whishlist</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link 
                        to="images/resource/products/1.jpg"
                        className="lightbox-image"
                        data-fancybox="shop-gallery"
                      >
                        <span className="fa fa-expand" />
                        <div className="toltip-content">
                          <p>Zoom In</p>
                        </div>
                      </Link> 
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Shop Item */}
            <div className="single-product-item col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="img-holder">
                <Link  to="shop-detail.html">
                  <img
                    width={270}
                    height={300}
                    src="/assets/images/resource/products/8.jpg"
                    className=""
                    alt=""
                  />
                </Link> 
              </div>
              <div className="title-holder text-center">
                <div className="static-content">
                  <h3 className="title text-center">
                    <Link  to="shop-detail.html">Product 08</Link> 
                  </h3>
                  <span className="price">
                    <span className="amount">
                      <span className="">$</span>90.00
                    </span>
                  </span>
                </div>
                <div className="overlay-content">
                  <ul className="clearfix">
                    <li>
                      <Link  to="shopping-cart.html">
                        <span className="fa fa-shopping-cart" />
                        <div className="toltip-content">
                          <p>Add to Cart</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link  to="shop-detail.html" className="">
                        <span className="fa fa-heart" />
                        <div className="toltip-content">
                          <p>Add Whishlist</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link 
                        to="images/resource/products/1.jpg"
                        className="lightbox-image"
                        data-fancybox="shop-gallery"
                      >
                        <span className="fa fa-expand" />
                        <div className="toltip-content">
                          <p>Zoom In</p>
                        </div>
                      </Link> 
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Shop Item */}
            <div className="single-product-item col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="img-holder">
                <Link  to="shop-detail.html">
                  <img
                    width={270}
                    height={300}
                    src="/assets/images/resource/products/9.jpg"
                    className=""
                    alt=""
                  />
                </Link> 
              </div>
              <div className="title-holder text-center">
                <div className="static-content">
                  <h3 className="title text-center">
                    <Link  to="shop-detail.html">Product 09</Link> 
                  </h3>
                  <span className="price">
                    <span className="amount">
                      <span className="">$</span>90.00
                    </span>
                  </span>
                </div>
                <div className="overlay-content">
                  <ul className="clearfix">
                    <li>
                      <Link  to="shopping-cart.html">
                        <span className="fa fa-shopping-cart" />
                        <div className="toltip-content">
                          <p>Add to Cart</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link  to="shop-detail.html" className="">
                        <span className="fa fa-heart" />
                        <div className="toltip-content">
                          <p>Add Whishlist</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link 
                        to="images/resource/products/1.jpg"
                        className="lightbox-image"
                        data-fancybox="shop-gallery"
                      >
                        <span className="fa fa-expand" />
                        <div className="toltip-content">
                          <p>Zoom In</p>
                        </div>
                      </Link> 
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Shop Item */}
            <div className="single-product-item col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="img-holder">
                <Link  to="shop-detail.html">
                  <img
                    width={270}
                    height={300}
                    src="/assets/images/resource/products/10.jpg"
                    className=""
                    alt=""
                  />
                </Link> 
              </div>
              <div className="title-holder text-center">
                <div className="static-content">
                  <h3 className="title text-center">
                    <Link  to="shop-detail.html">Product 10</Link> 
                  </h3>
                  <span className="price">
                    <span className="amount">
                      <span className="">$</span>90.00
                    </span>
                  </span>
                </div>
                <div className="overlay-content">
                  <ul className="clearfix">
                    <li>
                      <Link  to="shopping-cart.html">
                        <span className="fa fa-shopping-cart" />
                        <div className="toltip-content">
                          <p>Add to Cart</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link  to="shop-detail.html" className="">
                        <span className="fa fa-heart" />
                        <div className="toltip-content">
                          <p>Add Whishlist</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link 
                        to="images/resource/products/1.jpg"
                        className="lightbox-image"
                        data-fancybox="shop-gallery"
                      >
                        <span className="fa fa-expand" />
                        <div className="toltip-content">
                          <p>Zoom In</p>
                        </div>
                      </Link> 
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Shop Item */}
            <div className="single-product-item col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="img-holder">
                <Link  to="shop-detail.html">
                  <img
                    width={270}
                    height={300}
                    src="/assets/images/resource/products/11.jpg"
                    className=""
                    alt=""
                  />
                </Link> 
              </div>
              <div className="title-holder text-center">
                <div className="static-content">
                  <h3 className="title text-center">
                    <Link  to="shop-detail.html">Product 11</Link> 
                  </h3>
                  <span className="price">
                    <span className="amount">
                      <span className="">$</span>90.00
                    </span>
                  </span>
                </div>
                <div className="overlay-content">
                  <ul className="clearfix">
                    <li>
                      <Link  to="shopping-cart.html">
                        <span className="fa fa-shopping-cart" />
                        <div className="toltip-content">
                          <p>Add to Cart</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link  to="shop-detail.html" className="">
                        <span className="fa fa-heart" />
                        <div className="toltip-content">
                          <p>Add Whishlist</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link 
                        to="images/resource/products/1.jpg"
                        className="lightbox-image"
                        data-fancybox="shop-gallery"
                      >
                        <span className="fa fa-expand" />
                        <div className="toltip-content">
                          <p>Zoom In</p>
                        </div>
                      </Link> 
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* Shop Item */}
            <div className="single-product-item col-lg-4 col-md-6 col-sm-12 text-center">
              <div className="img-holder">
                <Link  to="shop-detail.html">
                  <img
                    width={270}
                    height={300}
                    src="/assets/images/resource/products/12.jpg"
                    className=""
                    alt=""
                  />
                </Link> 
              </div>
              <div className="title-holder text-center">
                <div className="static-content">
                  <h3 className="title text-center">
                    <Link  to="shop-detail.html">Product 12</Link> 
                  </h3>
                  <span className="price">
                    <span className="amount">
                      <span className="">$</span>90.00
                    </span>
                  </span>
                </div>
                <div className="overlay-content">
                  <ul className="clearfix">
                    <li>
                      <Link  to="shopping-cart.html">
                        <span className="fa fa-shopping-cart" />
                        <div className="toltip-content">
                          <p>Add to Cart</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link  to="shop-detail.html" className="">
                        <span className="fa fa-heart" />
                        <div className="toltip-content">
                          <p>Add Whishlist</p>
                        </div>
                      </Link> 
                    </li>
                    <li>
                      <Link 
                        to="images/resource/products/1.jpg"
                        className="lightbox-image"
                        data-fancybox="shop-gallery"
                      >
                        <span className="fa fa-expand" />
                        <div className="toltip-content">
                          <p>Zoom In</p>
                        </div>
                      </Link> 
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* Post Share Options */}
          <div className="styled-pagination text-center">
            <ul className="clearfix">
              <li className="prev">
                <Link  to="#">
                  <span className="fa fa-angle-left" />{" "}
                </Link> 
              </li>
              <li>
                <Link  to="#">1</Link> 
              </li>
              <li className="active">
                <Link  to="#">2</Link> 
              </li>
              <li>
                <Link  to="#">3</Link> 
              </li>
              <li className="next">
                <Link  to="#">
                  <span className="fa fa-angle-right" />{" "}
                </Link> 
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/*Sidebar Side*/}
      <div className="sidebar-side col-lg-4 col-md-12 col-sm-12">
        <Link side className="sidebar padding-left">
          {/* Search */}
          <div className="sidebar-widget search-box">
            <form
              method="post"
              action="https://themecraze.net/html/volia/contact.html"
            >
              <div className="form-group">
                <input
                  type="search"
                  name="search-field"
                  defaultValue=""
                  placeholder="Search..."
                  required=""
                />
                <button type="submit">
                  <i className="icon flaticon-search" />
                </button>
              </div>
            </form>
          </div>
          {/* Category Widget */}
          <div className="sidebar-widget categories">
            <h4 className="sidebar-title">Categories</h4>
            <div className="widget-content">
              {/* Blog Category */}
              <ul className="blog-categories">
                <li>
                  <Link  to="blog-single.html">
                    Business <span>03</span>
                  </Link> 
                </li>
                <li>
                  <Link  to="blog-single.html">
                    Conference <span>07</span>
                  </Link> 
                </li>
                <li>
                  <Link  to="blog-single.html">
                    Digital <span>06</span>
                  </Link> 
                </li>
                <li>
                  <Link  to="blog-single.html">
                    Music <span>02</span>
                  </Link> 
                </li>
                <li>
                  <Link  to="blog-single.html">
                    Startup <span>06</span>
                  </Link> 
                </li>
                <li>
                  <Link  to="blog-single.html">
                    Workshop <span>09</span>
                  </Link> 
                </li>
              </ul>
            </div>
          </div>
          {/* Post Widget */}
          <div className="sidebar-widget popular-posts">
            <h4 className="sidebar-title">Recent Posts</h4>
            <div className="widget-content">
              <Link rticle className="post">
                <div className="post-inner">
                  <figure className="post-thumb">
                    <Link  to="blog-single.html">
                      <img src="/assets/images/resource/post-thumb-1.jpg" alt="" />
                    </Link> 
                  </figure>
                  <div className="post-info">
                    <i className="fa fa-calendar-alt" /> 31/12/2023
                  </div>
                  <h6 className="text">
                    <Link  to="blog-single.html">
                      Chances are Good That There’s a Cloud Software
                    </Link> 
                  </h6>
                </div>
             </Link> 
              <Link rticle className="post">
                <div className="post-inner">
                  <figure className="post-thumb">
                    <Link  to="blog-single.html">
                      <img src="/assets/images/resource/post-thumb-2.jpg" alt="" />
                    </Link> 
                  </figure>
                  <div className="post-info">
                    <i className="fa fa-calendar-alt" /> 31/12/2023
                  </div>
                  <h6 className="text">
                    <Link  to="blog-single.html">
                      We Have Top Executive and Start Up Here Event 2023
                    </Link> 
                  </h6>
                </div>
             </Link> 
              <Link rticle className="post">
                <div className="post-inner">
                  <figure className="post-thumb">
                    <Link  to="blog-single.html">
                      <img src="/assets/images/resource/post-thumb-3.jpg" alt="" />
                    </Link> 
                  </figure>
                  <div className="post-info">
                    <i className="fa fa-calendar-alt" /> 31/12/2023
                  </div>
                  <h6>
                    <Link  to="blog-single.html">
                      Why Lead Generation is Key For Business Growth.
                    </Link> 
                  </h6>
                </div>
              </Link>
            </div>
          </div>
          {/* Tags Widget */}
          <div className="sidebar-widget popular-tags">
            <h4 className="sidebar-title">Tags</h4>
            <div className="widget-content">
              <Link  to="#">Business</Link> 
              <Link  to="#">Conference</Link> 
              <Link  to="#">Speaker</Link> 
              <Link  to="#">Digital</Link> 
              <Link  to="#">Development</Link> 
              <Link  to="#">Venue</Link> 
              <Link  to="#">Tech</Link> 
              <Link  to="#">Workshop</Link> 
            </div>
          </div>
        </Link>
      </div>
    </div>
  </div>
</div>

  )
}

export default SideBar